import "./src/style/main.scss"
